import src from "IMAGE";
export default { src, width: 1920, height: 999, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARElEQVR42l3MOw7AMAgD0Gwx5rP7/hctpEubwYKHkBewZQYBkDvPfL3brlVVmgwqU19n+zzMMoeI0O1FsitN5IT62/QA2XgHQEelKZ8AAAAASUVORK5CYII="};
